import BigNumber from 'bignumber.js'

import { CardBody, Flex, Text, CardRibbon } from '@pancakeswap/uikit'
import ConnectWalletButton from 'components/ConnectWalletButton'
import { useTranslation } from 'contexts/Localization'
import { BIG_ZERO } from 'utils/bigNumber'
import { TokenPairImage } from 'components/TokenImage'
import { usePool } from 'state/pools/hooks'
import AprRow from './AprRow'
import { StyledCard } from './StyledCard'
import PoolCardHeader, { PoolCardHeaderTitle } from './PoolCardHeader'
import CardActions from './CardActions'
import { useEffect, useState } from 'react'

const PoolCard: React.FC<{ pool: any; account: string }> = ({ pool, account }) => {
  const { sousId, stakingToken, earningToken, isFinished, userData } = pool
  const { t } = useTranslation()
  const stakedBalance = userData?.stakedBalance ? new BigNumber(userData.stakedBalance) : BIG_ZERO
  const accountHasStakedBalance = stakedBalance.gt(0)

  const bnbPool = usePool(38)
  // const normalPrice = Number(bnbPool.pool.busdPrice) * Number(bnbPool.pool.tokenPrice)
  const normalPriceBnb = Number(bnbPool.pool.busdPrice) //new BigNumber(normalPrice / Number(bnbPool.pool.tokenPrice))
  const priceInBnb = pool.tokenPrice
    ? new BigNumber(pool.earningTokenPrice).times(new BigNumber(pool.tokenPrice.toString()))
    : BIG_ZERO

  // const isCakePool = earningToken.symbol === 'HODLX' && stakingToken.symbol === 'HODLX'
  const discountRate = 1 - priceInBnb.div(normalPriceBnb).toNumber()

  const discountRatePercent =
    pool.discountRate !== undefined ? pool.discountRate.toString() : (Number(discountRate) * 100).toFixed(0)
  const discountSave = bnbPool.pool.busdPrice
    ? new BigNumber(bnbPool.pool.busdPrice.toString())
        .times(new BigNumber(bnbPool.pool.tokenPrice.toString()))
        .times(new BigNumber(discountRate))
    : BIG_ZERO

  const busdPrice = bnbPool.pool.tokenPrice
    ? priceInBnb.times(new BigNumber(bnbPool.pool.tokenPrice.toString())).toNumber()
    : 0

  const [nftFetched, setNftFetched] = useState(false)
  const [gfNfts, setGFNfts] = useState([])

  useEffect(() => {
    if (nftFetched || userData.gfNfts?.length > 0 || !userData.gfTokenIds || userData.gfTokenIds?.length === 0) return

    setNftFetched(true)

    const loadNFTs = async () => {
      const res = await fetch('https://rest.hodlbot.org/api/ast/NFTrank', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ids: userData.gfTokenIds, asset: 'Gem Fighter' }),
      })
      const fetchedGFNfts = await res.json()
      setGFNfts(fetchedGFNfts)
    }
    loadNFTs()
  }, [userData])

  return (
    <StyledCard
      isFinished={isFinished && sousId !== 0 && sousId !== 15}
      ribbon={isFinished && <CardRibbon variantColor="textDisabled" text={t('Finished')} />}
    >
      <PoolCardHeader isStaking={accountHasStakedBalance} isFinished={isFinished && sousId !== 0 && sousId !== 15}>
        <PoolCardHeaderTitle
          title={t('Swap 2 Gem Fighter NFTs for 1 Fresh One!')}
          subTitle={t('Mint a new Gem Fighter NFT with full odds')}
        />
        <TokenPairImage primaryToken={earningToken} secondaryToken={stakingToken} width={64} height={64} />
      </PoolCardHeader>
      <CardBody>
        <AprRow
          pool={pool}
          stakedBalance={stakedBalance}
          discountRatePercent={discountRatePercent}
          discountSave={discountSave}
          busdPrice={busdPrice}
        />
        <Flex alignItems="center" justifyContent="space-between">
          <Text>{`${t('Current ID:')}`}</Text>
          <Text>#{bnbPool.pool.tokenId ?? '-'}</Text>
        </Flex>
        <Flex mt="24px" flexDirection="column">
          {account ? (
            <CardActions
              pool={pool}
              stakedBalance={stakedBalance}
              discountSave={discountSave}
              busdPrice={busdPrice}
              gfNfts={gfNfts}
            />
          ) : (
            <>
              <ConnectWalletButton />
            </>
          )}
        </Flex>
      </CardBody>
    </StyledCard>
  )
}

export default PoolCard
